import * as Sentry from "@sentry/react";

const isProduction = import.meta.env.VITE_NODE_ENV === "production";

if (isProduction) {
  Sentry.init({
    dsn: "https://9584dd158f5be09e03bb40ba9b540eb1@o4507181747077120.ingest.us.sentry.io/4507301921947648",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      "localhost",
      "https://iris.gravoc.com",
      "http://gravoccloud-v2-dev.xpgwmejizj.us-east-1.elasticbeanstalk.com"
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: isProduction ? "prod" : "dev"
  });
}
